import i18n from 'i18next';
import { prizeVisibleTypes, prizeQuantityLimitedTypes } from 'config/promoPrizeTypes';

export const GAME_EDITOR_WIDTH = 960;
export const KEY_VISION_HEIGHT = 200;
export const GAME_EDITOR_DESIGN_WIDTH = 592;
const DEFAULT_EDITOR_PRIZE_CARD_NUMBER = 4;
// 網頁背景
export const POINTS_REDEEM_BACKGROUND_IMAGE_URL =
    'https://s3.ap-southeast-1.amazonaws.com/assets.fevercdn.com/promotion/img/PointsRedeem_BG.png';

export const PRIZE_STATE = {
    UNREDEEMABLE: 'unRedeemable', //不足的
    REDEEMABLE: 'redeemable', //足夠
    IS_LOCKED: 'isLocked', //達到上限
    IS_RUNOUT: 'isRunout', // 發送完畢
    IS_HIDDEN: 'isHidden' // 發送完畢
};

const DEFAULT_PRIZE_INFO = {
    key: 0,
    title: i18n.t('label.pick_the_prize.prize_card.defalut.title'),
    caption: i18n.t('label.pick_the_prize.prize_card.defalut.desc'),
    imageSrc: 'https://assets.fevercdn.com/promotion/img/prizeImg.jpg',
    isLimited: prizeQuantityLimitedTypes.UNLIMITED,
    isVisible: prizeVisibleTypes.VISIBLE,
    redeemPoints: 1
};

export const DEFAULT_PRIZE_INFO_LIST = new Array(DEFAULT_EDITOR_PRIZE_CARD_NUMBER)
    .fill(DEFAULT_PRIZE_INFO)
    .reduce((result, current, index) => {
        result[index] = {
            ...current,
            key: index
        };
        return result;
    }, {});
